import AnimationsBall from '../Animations/AnimationsBall'

export default function Ball() {
    return (
        <AnimationsBall />
    )
}

